import { useState } from "react"
import { useInterval } from "react-use"

export function useTimeTick(intervalMs = 60_000): number {
	const [tick, setTick] = useState(0)
	useInterval(() => setTick((t) => t + 1), intervalMs)
	return tick
}
